export default "__VITE_ASSET__DirT_xHa__"